import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { clearSession, getLoggedUserProfile } from "../../utils/auth";

interface ContactAdminPageProps {
  /** Module the user lacks access to. Defaults to "Marketing Analyzer". */
  moduleLabel?: string;
}

/**
 * Phase 1 gate page for v2 users without `marketing_analyzer` assigned.
 * Mirrors the contact-admin pattern from mk-admin-app and mk-copilot.
 */
export function ContactAdminPage({
  moduleLabel = "Marketing Analyzer",
}: ContactAdminPageProps) {
  const profile = getLoggedUserProfile();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "grey.50",
        px: 2,
      }}
    >
      <Card sx={{ maxWidth: 480, width: "100%" }}>
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={3} alignItems="center" textAlign="center">
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                bgcolor: "grey.100",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LockOutlinedIcon
                sx={{ width: 28, height: 28, color: "grey.600" }}
              />
            </Box>
            <Typography variant="h6" fontWeight={600}>
              You don&apos;t have access to {moduleLabel}
            </Typography>
            <Typography color="text.secondary">
              Your account isn&apos;t assigned to this module. Contact your Org
              Admin to request access.
            </Typography>
            {profile?.email && (
              <Box
                sx={{
                  border: 1,
                  borderColor: "divider",
                  borderRadius: 1,
                  p: 2,
                  width: "100%",
                  bgcolor: "grey.50",
                }}
              >
                <Typography variant="caption" color="text.secondary">
                  Signed in as
                </Typography>
                <Typography fontWeight={500}>{profile.email}</Typography>
              </Box>
            )}
            <Button onClick={() => clearSession()} fullWidth variant="outlined">
              Sign out
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
